import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import HistoryQPage2, { IProps } from './index';
import { InputFieldConfig } from '../../../../types';

const mapStateToProps = (state: ApplicationState): IProps => {
  const {
    PrevUKOtherVisa: prevUKOtherVisaConfig,
    UKLeaveToRemain: ukLeaveToRemainConfig,
    PrevRejections: prevRejectionsConfig,
    PrevRejectionReason: prevRejectionReasonConfig,
    PrevVisaRefusal: prevVisaRefusalConfig,
    PrevNonUKVisaRefusal: prevNonUKVisaRefusalConfig,
  }: {
    PrevUKOtherVisa: InputFieldConfig;
    UKLeaveToRemain: InputFieldConfig;
    PrevRejections: InputFieldConfig;
    PrevRejectionReason: InputFieldConfig;
    PrevVisaRefusal: InputFieldConfig;
    PrevNonUKVisaRefusal: InputFieldConfig;
  } = state.student.config.Checklist.History.Page2;

  const {
    hasOtherUkVisas = undefined,
    otherUkVisas = [],
    hasLeaveToRemain = undefined,
    hasBorderRefusal = undefined,
    borderRefusalReason = '',
    hasUkVisaRefusals = undefined,
    ukVisaRefusals = [],
    hasOtherVisaRefusals = undefined,
    otherVisaRefusals = [],
  } = state.student.history;

  const allVisasComplete = (amount: number): boolean => {
    let complete = (hasOtherUkVisas === true && amount > 0) || hasOtherUkVisas === false;
    for (let i = 0; i < amount; i++) {
      complete = complete && otherUkVisas[i].visaType !== '' && otherUkVisas[i].year !== '';
    }
    return complete;
  };

  const allRefusalsComplete = (amount: number): boolean => {
    let complete = (hasUkVisaRefusals === true && amount > 0) || hasUkVisaRefusals === false;
    for (let i = 0; i < amount; i++) {
      complete = complete && ukVisaRefusals[i].visaType !== '' && ukVisaRefusals[i].year !== '';
    }
    return complete;
  };

  const allNonUKRefusalsComplete = (amount: number): boolean => {
    let complete = (hasOtherVisaRefusals === true && amount > 0) || hasOtherVisaRefusals === false;
    for (let i = 0; i < amount; i++) {
      complete =
        complete &&
        otherVisaRefusals[i].country !== '' &&
        otherVisaRefusals[i].isStudentVisa !== undefined &&
        otherVisaRefusals[i].year !== '';
    }
    return complete;
  };

  const prevUKOtherVisaVisible = prevUKOtherVisaConfig?.visible ?? true;
  const ukLeaveToRemainVisible = ukLeaveToRemainConfig?.visible ?? true;
  const prevRejectionsVisible = prevRejectionsConfig?.visible ?? true;
  const prevRejectionReasonVisible = (prevRejectionReasonConfig?.visible ?? true) && hasBorderRefusal === true;
  const prevVisaRefusalVisible = prevVisaRefusalConfig?.visible ?? true;
  const prevNonUKVisaRefusalVisible = prevNonUKVisaRefusalConfig?.visible ?? true;

  const prevUKOtherVisaMandatory = prevUKOtherVisaConfig?.mandatory ?? true;
  const ukLeaveToRemainMandatory = ukLeaveToRemainConfig?.mandatory ?? true;
  const prevRejectionsMandatory = prevRejectionsConfig?.mandatory ?? true;
  const prevRejectionReasonMandatory = prevRejectionReasonConfig?.mandatory ?? true;
  const prevVisaRefusalMandatory = prevVisaRefusalConfig?.mandatory ?? true;
  const prevNonUKVisaRefusalMandatory = prevNonUKVisaRefusalConfig?.mandatory ?? true;

  // prettier-ignore
  const complete =
    (!prevUKOtherVisaVisible || !prevUKOtherVisaMandatory || hasOtherUkVisas !== undefined) &&
    (!ukLeaveToRemainVisible || !ukLeaveToRemainMandatory || hasLeaveToRemain !== undefined) &&
    (!prevRejectionsVisible || !prevRejectionsMandatory || hasBorderRefusal !== undefined) &&
    (!prevRejectionReasonVisible || !prevRejectionReasonMandatory || borderRefusalReason !== '') &&
    (!prevVisaRefusalVisible || !prevVisaRefusalMandatory || ukVisaRefusals !== undefined) &&
    (!prevNonUKVisaRefusalVisible || !prevNonUKVisaRefusalMandatory || hasOtherVisaRefusals !== undefined) &&
    allVisasComplete(Number(otherUkVisas.length)) &&
    allRefusalsComplete(Number(ukVisaRefusals.length)) &&
    allNonUKRefusalsComplete(Number(otherVisaRefusals.length));

  return {
    sectionTitle: state.student.config.Checklist.History.shortTitle,
    complete,
    currentStep: 2,
    steps: 3,
    hasOtherUkVisas,
    prevUKOtherVisaVisible,
    prevUKOtherVisaConfig,
    otherUkVisas,
    hasLeaveToRemain,
    ukLeaveToRemainVisible,
    ukLeaveToRemainConfig,
    hasBorderRefusal,
    prevRejectionsVisible,
    prevRejectionsConfig,
    borderRefusalReason,
    prevRejectionReasonVisible,
    prevRejectionReasonConfig,
    hasUkVisaRefusals,
    prevVisaRefusalVisible,
    prevVisaRefusalConfig,
    ukVisaRefusals,
    hasOtherVisaRefusals,
    prevNonUKVisaRefusalVisible,
    prevNonUKVisaRefusalConfig,
    otherVisaRefusals,
    config: state.student.config,
  };
};

export default connect(mapStateToProps)(HistoryQPage2);
